import { useState } from 'react';
import { useNewsletter } from '@/hooks/useNewsletter';

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const { subscribe, isLoading } = useNewsletter();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const result = await subscribe(email);
    
    if (result.success) {
      setEmail('');
      setShowSuccess(true);
      
      // Ocultar mensagem após 3 segundos
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    }
  };

  return (
    <div className="mt-8">
      <h4 className="text-sm font-semibold text-white mb-3">Newsletter Bailão</h4>
      <p className="text-xs text-muted-foreground mb-4">
        Receba novidades por e-mail
      </p>
      
      {showSuccess ? (
        <div className="py-3 px-4 bg-green-500/10 border border-green-500/30 rounded text-green-400 text-sm text-center">
          Inscrição realizada.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex space-x-2">
          <input 
            type="email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Seu e-mail" 
            required 
            disabled={isLoading}
            className="flex-1 px-3 py-2 bg-input border border-border rounded text-sm focus:outline-none focus:border-accent disabled:opacity-50" 
          />
          <button 
            type="submit" 
            disabled={isLoading}
            className="px-4 py-2 bg-secondary hover:bg-secondary-hover text-white rounded text-sm transition-colors disabled:opacity-50"
          >
            {isLoading ? 'Enviando...' : 'Inscrever'}
          </button>
        </form>
      )}
    </div>
  );
};

export default NewsletterForm;